import React, { useEffect, useState } from 'react';
import CenterModalWindow from '../../layout/ReusableComponent/CenterModalWindow/CenterModalWindow';
import '../../layout/ReusableComponent/CenterModalWindow/CenterModalWindow.css';

export default function StorageBoxNameModal({
  isOpen,
  onClose,
  title,
  label,
  initialName = '',
  confirmLabel = 'Save',
  busy = false,
  onSubmit,
}) {
  const [name, setName] = useState(initialName);

  useEffect(() => {
    if (isOpen) setName(initialName);
  }, [isOpen, initialName]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed || busy) return;
    await onSubmit(trimmed);
  };

  return (
    <CenterModalWindow
      isOpen={isOpen}
      onClose={onClose}
      width="min(440px, calc(100vw - 32px))"
      height="auto"
      contentStyle={{ height: 'auto' }}
      contentClassName="sb-name-modal"
    >
      <form className="sb-name-modal__body" onSubmit={handleSubmit} data-modal-scroll-port>
        <h3 className="sb-name-modal__title">{title}</h3>
        <label className="sb-name-modal__field">
          <span>{label}</span>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
            maxLength={240}
            disabled={busy}
          />
        </label>
        <div className="sb-name-modal__actions">
          <button type="button" className="sb-secondary-btn" onClick={onClose} disabled={busy}>
            Cancel
          </button>
          <button type="submit" className="sb-primary-btn sb-name-modal__submit" disabled={busy || !name.trim()}>
            {busy ? 'Saving…' : confirmLabel}
          </button>
        </div>
      </form>
    </CenterModalWindow>
  );
}
